import {
  BARK_FUEL_LOADS,
  ELEVATED_FUEL_LOADS,
  NEAR_SURFACE_FUEL_LOADS,
  SURFACE_FUEL_LOADS
} from './constants';
import {
  PREFIX_DF,
  PREFIX_KBDI,
  PREFIX_WIND_DIR,
  PREFIX_WIND_MAG_KPH
} from '../shared/behaviour_models_utils';
import {
  calculateFFM_C,
  calculateFFM_DT,
  calculateFFM_NT,
  calculateFFM_PM
} from '../shared/ffm';

export {
  calculateFFM_PM,
  calculateFFM_DT,
  calculateFFM_NT,
  calculateFFM_C
};

export function fuelLoad(map, hazard) {
  return map[hazard];
}

export function totalFuelLoad(vars) {
  return fuelLoad(SURFACE_FUEL_LOADS, vars.surface_hazard) +
    fuelLoad(NEAR_SURFACE_FUEL_LOADS, vars.near_surface_hazard) +
    fuelLoad(ELEVATED_FUEL_LOADS, vars.elevated_hazard) +
    fuelLoad(BARK_FUEL_LOADS, vars.bark_hazard);
}

export function surfacePlusNearLoad(vars) {
  return fuelLoad(SURFACE_FUEL_LOADS, vars.surface_hazard) +
    fuelLoad(NEAR_SURFACE_FUEL_LOADS, vars.near_surface_hazard);
}

export function calculateDIR(wd) {
  const windDir = wd[PREFIX_WIND_DIR];
  if (typeof windDir === 'undefined') {
    return undefined;
  }
  return windDir < 180 ? windDir + 180 : windDir - 180;
}

export function calculatePhiMd(fmc) {
  if (typeof fmc === 'undefined') {
    return undefined;
  }
  if (fmc <= 4.1) {
    return 1;
  }
  if (fmc >= 24) {
    return 0;
  }
  return 0.9082 + 0.1206 * fmc -
    0.03106 * Math.pow(fmc, 2) +
    0.001853 * Math.pow(fmc, 3) -
    0.00003467 * Math.pow(fmc, 4);
}

export function calculateWind2m(wd, wrf) {
  const wind10m = wd[PREFIX_WIND_MAG_KPH];
  if (typeof wind10m === 'undefined' || !wrf) {
    return undefined;
  }
  return wind10m / wrf;
}

export function calculatePhiTheta(slope) {
  const expPos = Math.pow(2, slope / 10);
  const expNeg = Math.pow(2, -slope / 10);
  const factor = slope > 0 ? expPos : expNeg / (2 * expNeg - 1);
  return Math.min(factor, 4);
}

export function calculatePhiFa(df) {
  return 1.008 / (1 + 104.9 * Math.exp(-0.9306 * df));
}

export function getDf(wd) {
  const df = wd[PREFIX_DF];
  return typeof df === 'undefined' ? undefined : df;
}

export function getKbdi(wd) {
  const kbdi = wd[PREFIX_KBDI];
  if (kbdi === null || kbdi === undefined || kbdi === '') {
    return undefined;
  }
  const n = Number(kbdi);
  return Number.isFinite(n) ? n : undefined;
}

export function calculateFdiForSpotting(df, rh, temp, wind10m, wrf) {
  return 2 * Math.exp(
    -0.45 + 0.987 * Math.log(df) - 0.0345 * rh + 0.0338 * temp + 0.0234 * wind10m * 3 / wrf
  );
}

export function calculateSpottingDistance(frosWithSlope, slope, totalFuelLoad) {
  const inner = (frosWithSlope / Math.exp(0.069 * slope) / 1000) *
    (4.17 - 0.033 * totalFuelLoad) - 0.36;
  return Math.max(0, inner * 1000);
}

export function calculateFrosWithSlope(fdi, totalFuelLoad, slope) {
  return 0.0012 * fdi * totalFuelLoad * Math.exp(0.069 * slope) * 1000;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/vesta_mk2/shared.js